// extracted by mini-css-extract-plugin
module.exports = {"close":"NavPanelEndUser_close__1K2hU","user":"NavPanelEndUser_user__Ktie_","name":"NavPanelEndUser_name__TTKNS"};